<div *ngIf="loading" class="loading-content-chart">
  <lib-loading></lib-loading>
</div>

<ng-container *ngIf="!loading">

  <h1 class="title-chart">Volume de atendimento por canal</h1>
  
  <div  class="content-canvas">
    <div class="chart-contact-type">
      <canvas baseChart id="myChart"
        (window:resize)="onResize($event)" [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
        [plugins]="barChartPlugins" [legend]="false" [chartType]="barChartType" [colors]="chartColors">
      </canvas>
    </div>
  </div>
  
</ng-container>